export default {
  "mountTitle": "Mount monitoring",
  "mountDescription": "Track directory usage over time and trigger on-demand scans when you need detail.",
  "adminHint": "Admin-only: Use absolute paths to monitor any location on the server.",
  "userHint": "You can monitor folders inside {{path}}.",
  "homeDirectory": "your home directory",
  "scanHint": "Scans run in the background and may take a while on large directories.",
  "networkHint": "Some network mounts may report partial results if certain files are unreadable.",
  "path": "Path",
  "label": "Label",
  "labelExample": "e.g. Downloads",
  "ignoreQuotas": "Ignore quotas",
  "quotaHint": "Use filesystem totals instead of any user quota limits.",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "enabledHint": "Enabled paths are included in monitoring and scans.",
  "addPath": "Add path",
  "paths": "Monitored paths",
  "refresh": "Refresh",
  "lastSize": "Last size",
  "lastScan": "Last scan",
  "status": "Status",
  "actions": "Actions",
  "emptyPaths": "No monitored paths yet. Add one above to start tracking usage.",
  "notScanned": "Not scanned",
  "scanning": "Scanning…",
  "scanNow": "Scan now",
  "cancel": "Cancel",
  "remove": "Remove",
  "usageLoadFailed": "Unable to load disk usage.",
  "metricsLoadFailed": "Unable to load system metrics.",
  "metricsUnexpected": "Unexpected system metrics response.",
  "mountLoadFailed": "Unable to load monitored paths.",
  "addFailed": "Unable to add path.",
  "removeFailed": "Unable to remove path.",
  "scanFailed": "Unable to scan path.",
  "pathAdded": "Mount path added",
  "pathRemoved": "Path removed",
  "scanWarnings": "Scan completed with warnings",
  "warningDetail": "{{warning}} Sizes may be slightly under-reported.",
  "permission_denied": "Some items could not be read due to filesystem permissions.",
  "io_error": "Some items could not be read due to I/O errors.",
  "partial_read": "Scan completed with warnings.",
  "unreadableSamples": "Unreadable samples:",
  "morePaths_one": "And {{formattedCount}} more…",
  "morePaths_other": "And {{formattedCount}} more…",
  "morePaths_many": "And {{formattedCount}} more…",
  "scanComplete": "Scan complete",
  "resultsUpdated": "Usage results updated.",
  "scanCancelled": "Stopped watching. The scan keeps running and its total will appear here when it finishes.",
  "stopWatching": "Stop watching",
  "lastScanFailed": "Last scan failed",
  "lastScanTimedOut": "Last scan failed: timed out",
  "lastScanInterrupted": "Last scan interrupted",
  "cpuTopology": "{{cores}} cores / {{threads}} threads",
  "load": "Load: {{value}}",
  "used": "{{value}} used",
  "total": "{{value}} total",
  "free": "{{value}} free",
  "pathCount_one": "Monitored paths: {{formattedCount}}",
  "pathCount_other": "Monitored paths: {{formattedCount}}",
  "pathCount_many": "Monitored paths: {{formattedCount}}",
  "title": "System Metrics",
  "description": "CPU, memory, and disk usage for your account.",
  "usageUnavailable": "Disk usage is currently unavailable. Please try again later.",
  "metricsUnavailable": "System metrics are unavailable. Try refreshing the page.",
  "userMissing": "User account not found",
  "userMissingHelp": "Your dashboard account does not have a corresponding Linux user account on this server. CPU and memory metrics are not available. Contact an administrator if you need a system account.",
  "noActivity": "No activity detected",
  "noActivityHelp": "No processes are currently running under your account. This can be normal until applications or services start running under your user. If this persists unexpectedly, contact an administrator.",
  "storage": "Storage",
  "quota": "Quota",
  "system": "System",
  "manageMounts": "Manage mounts",
  "manage": "Manage",
  "usage": "Usage",
  "enableQuotas": "To track your personal disk usage, contact your administrator to enable quotas for your account.",
  "noDisk": "No disk data",
  "configure": "Configure",
  "cpu": "CPU",
  "memory": "Memory",
  "disk": "Disk",
  "sampling": "Sampling…",
  "noProcesses": "No user processes detected.",
  "cpuReadFailed": "Unable to read system CPU stats.",
  "processReadFailed": "Unable to read process data.",
  "samplingTimeout": "Sampling timed out.",
  "memoryTotalFailed": "Unable to determine total memory.",
  "cpuFastReadFailed": "Unable to read system CPU stats after fast-sample.",
  "processFastReadFailed": "Unable to read process data after fast-sample.",
  "cpuComputeFailed": "Unable to compute CPU usage."
} as const;
